import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStore } from '../../app/stores/store';
import { Card, Grid, Header, Tab } from 'semantic-ui-react';
import { ProfileCard } from './ProfileCard';

const ProfileFollowings: React.FC = observer(() => {
  const { profileStore } = useStore();
  const { profile, followings, loadingFollowings, activeTab } = profileStore;
  const wording =
    activeTab === 3
      ? `People following ${profile?.displayName}`
      : `People ${profile?.displayName} is following`;

  return (
    <Tab.Pane loading={loadingFollowings}>
      <Grid>
        <Grid.Column width={16}>
          <Header floated="left" icon="user" content={wording}></Header>
        </Grid.Column>
        <Grid.Column width={16}>
          <Card.Group itemsPerRow={4}>
            {followings.map((profile) => (
              <ProfileCard key={profile.username} profile={profile} />
            ))}
          </Card.Group>
        </Grid.Column>
      </Grid>
    </Tab.Pane>
  );
});

export { ProfileFollowings };
